// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"4edf5246","453":"56e1a5d4","695":"6b93cccd"}[chunkId] + ".chunk.js";
};